export default __webpack_public_path__ + "assets/icon-delivery-truck.cfced4fb.webp";